module.exports = __webpack_public_path__ + "img/dinersclub.beb29f5d.svg";